const CUSTOM_VALUE = 'Custom';

function getVariantSelects() {
  return document.querySelectorAll('variant-picker select.variant-option__select');
}

function getSelectByOptionName(optionName) {
  if (!optionName) return null;
  return document.querySelector(`variant-picker select.variant-option__select[data-option-name="${optionName}"]`);
}

function getLongerSideDropdown() {
  return document.querySelector('[data-pdp-longer-side]');
}

function getLongerSideSelect() {
  return getLongerSideDropdown()?.querySelector('[data-pdp-custom-trigger]') ?? null;
}

function isOptionCustom(optionName, triggerValue = CUSTOM_VALUE) {
  const longerSelect = getLongerSideSelect();
  const customDims = getMutualCustomDimsPanel();
  if (longerSelect && customDims?.dataset.watchLongerDropdown === 'true') {
    return longerSelect.value === triggerValue;
  }
  const select = getSelectByOptionName(optionName);
  return select ? select.value === triggerValue : false;
}

function getSideDropdown() {
  return document.querySelector('[data-pdp-side-dropdown]:not([data-pdp-longer-side])');
}

function isSideDropdownCustom(sideDropdown, triggerValue = CUSTOM_VALUE) {
  const select = sideDropdown?.querySelector('[data-pdp-custom-trigger]');
  return select ? select.value === triggerValue : false;
}

function getMutualCustomDimsPanel() {
  return document.querySelector('[data-pdp-custom-dimensions]:not([data-always-visible="true"])');
}

function hasMutualCustomMode() {
  const panel = getMutualCustomDimsPanel();
  const sideDropdown = getSideDropdown();
  const longerDropdown = getLongerSideDropdown();
  if (longerDropdown && sideDropdown && panel) return true;
  return !!(panel && sideDropdown && panel.dataset.watchOption);
}

function initLongerSideFallbacks() {
  const longerDropdown = getLongerSideDropdown();
  if (!longerDropdown) return;

  const customDims = getMutualCustomDimsPanel();
  if (customDims && customDims.dataset.watchLongerDropdown !== 'true') {
    customDims.dataset.watchLongerDropdown = 'true';
  }

  document.querySelectorAll('[data-pdp-deposit-note]').forEach((note) => {
    if (note.dataset.watchLongerDropdown !== 'true') {
      note.dataset.watchLongerDropdown = 'true';
    }
    if (getSideDropdown() && note.dataset.alsoWatchSideDropdown !== 'true') {
      note.dataset.alsoWatchSideDropdown = 'true';
    }
  });
}

function isFieldInHiddenCustomPanel(field) {
  const panel = field.closest('[data-pdp-custom-panel]');
  return panel?.classList.contains('hidden') ?? false;
}

function setHiddenFieldState(container, visible) {
  if (!container) return;
  container.querySelectorAll('input, textarea, select').forEach((field) => {
    if (field.matches('[data-pdp-custom-trigger]')) return;
    const effectivelyVisible = visible && !isFieldInHiddenCustomPanel(field);
    const forceRequired = field.hasAttribute('data-pdp-dimension-input') || field.hasAttribute('data-pdp-custom-input');
    if (effectivelyVisible) {
      if (forceRequired || field.dataset.pdpWasRequired === 'true') field.required = true;
      field.disabled = false;
    } else {
      if (field.required) field.dataset.pdpWasRequired = 'true';
      field.required = false;
      field.disabled = true;
      if (field.tagName === 'SELECT') return;
      field.value = '';
    }
  });
}

function resetSideDropdownSelect(sideDropdown, triggerValue) {
  const select = sideDropdown?.querySelector('[data-pdp-custom-trigger]');
  if (!select || select.value !== triggerValue) return;
  select.value = select.options[0]?.value || '';
}

function setSideDropdownPropertyActive(active) {
  const shorterSelect = getSideDropdown()?.querySelector('[data-pdp-custom-trigger]');
  if (!shorterSelect) return;
  if (active) {
    if (shorterSelect.dataset.pdpPropertyName) {
      shorterSelect.setAttribute('name', shorterSelect.dataset.pdpPropertyName);
    }
    shorterSelect.disabled = false;
    if (shorterSelect.dataset.pdpWasRequired === 'true') shorterSelect.required = true;
    return;
  }
  if (!shorterSelect.dataset.pdpPropertyName) {
    shorterSelect.dataset.pdpPropertyName = shorterSelect.getAttribute('name') || '';
  }
  if (shorterSelect.required) shorterSelect.dataset.pdpWasRequired = 'true';
  shorterSelect.removeAttribute('name');
  shorterSelect.required = false;
  shorterSelect.disabled = true;
}

function updateDepositNotes() {
  const mutualPanel = getMutualCustomDimsPanel();
  const sideDropdown = getSideDropdown();
  const longerDropdown = getLongerSideDropdown();

  document.querySelectorAll('[data-pdp-deposit-note]').forEach((note) => {
    const watchOption = note.dataset.watchOption || '';
    const trigger = note.dataset.triggerValue || CUSTOM_VALUE;
    let show = watchOption ? isOptionCustom(watchOption, trigger) : false;
    const watchLonger =
      note.dataset.watchLongerDropdown === 'true' ||
      (mutualPanel && longerDropdown && mutualPanel.dataset.watchLongerDropdown === 'true');
    if (watchLonger) {
      const longerTrigger = longerDropdown?.dataset.triggerValue || trigger;
      if (isSideDropdownCustom(longerDropdown, longerTrigger)) show = true;
    }
    const alsoWatchSide =
      note.dataset.alsoWatchSideDropdown === 'true' ||
      (mutualPanel && sideDropdown && watchOption === mutualPanel.dataset.watchOption);
    if (alsoWatchSide) {
      const sideTrigger = sideDropdown?.dataset.triggerValue || trigger;
      if (isSideDropdownCustom(sideDropdown, sideTrigger)) show = true;
    }
    note.classList.toggle('hidden', !show);
  });
}

function syncMutualCustomSizeUI() {
  const sideDropdown = getSideDropdown();
  const customDims = getMutualCustomDimsPanel();
  const longerDropdown = getLongerSideDropdown();
  if (!sideDropdown || !customDims) return;

  const trigger = customDims.dataset.triggerValue || sideDropdown.dataset.triggerValue || CUSTOM_VALUE;
  const shorterSelect = sideDropdown.querySelector('[data-pdp-custom-trigger]');
  const shorterCustomPanel = sideDropdown.querySelector('[data-pdp-custom-panel]');
  const shorterField = sideDropdown.querySelector('.pdp-side-dropdown__field');
  const useLongerDropdown = customDims.dataset.watchLongerDropdown === 'true' && longerDropdown;
  const longerSelect = useLongerDropdown
    ? longerDropdown.querySelector('[data-pdp-custom-trigger]')
    : getSelectByOptionName(customDims.dataset.watchOption || '');
  const longerField = useLongerDropdown
    ? longerDropdown.querySelector('.pdp-side-dropdown__field')
    : longerSelect?.closest('.variant-option');
  const longerCustom = longerSelect?.value === trigger;
  const shorterCustom = shorterSelect?.value === trigger;

  if (longerCustom) {
    resetSideDropdownSelect(sideDropdown, trigger);
    setSideDropdownPropertyActive(false);
    sideDropdown.classList.add('hidden');
    setHiddenFieldState(sideDropdown, false);
    const longerCustomPanel = longerDropdown?.querySelector('[data-pdp-custom-panel]');
    longerCustomPanel?.classList.add('hidden');
    setHiddenFieldState(longerCustomPanel, false);
    customDims.classList.remove('hidden');
    setHiddenFieldState(customDims, true);
    longerField?.classList.remove('hidden');
    return;
  }

  if (shorterCustom) {
    setSideDropdownPropertyActive(false);
    customDims.classList.add('hidden');
    setHiddenFieldState(customDims, false);
    sideDropdown.classList.remove('hidden');
    if (longerDropdown) {
      longerDropdown.classList.add('hidden');
      setHiddenFieldState(longerDropdown, false);
    }
    shorterField?.classList.add('hidden');
    shorterCustomPanel?.classList.remove('hidden');
    setHiddenFieldState(shorterCustomPanel, true);
    return;
  }

  if (longerDropdown) {
    longerDropdown.classList.remove('hidden');
    const longerCustomPanel = longerDropdown.querySelector('[data-pdp-custom-panel]');
    longerCustomPanel?.classList.add('hidden');
    setHiddenFieldState(longerCustomPanel, false);
    setHiddenFieldState(longerDropdown, true);
  }
  sideDropdown.classList.remove('hidden');
  longerField?.classList.remove('hidden');
  shorterField?.classList.remove('hidden');
  shorterCustomPanel?.classList.add('hidden');
  setHiddenFieldState(shorterCustomPanel, false);
  customDims.classList.add('hidden');
  setHiddenFieldState(customDims, false);
  setSideDropdownPropertyActive(true);
  setHiddenFieldState(sideDropdown, true);
}

function toggleCustomPanels() {
  if (hasMutualCustomMode()) {
    syncMutualCustomSizeUI();
    updateDepositNotes();
    syncLengthAddonPrice();
    return;
  }

  document.querySelectorAll('[data-pdp-custom-dimensions]').forEach((panel) => {
    if (panel.dataset.alwaysVisible === 'true') return;
    const trigger = panel.dataset.triggerValue || CUSTOM_VALUE;
    const watchOption = panel.dataset.watchOption || '';
    const watchLonger = panel.dataset.watchLongerDropdown === 'true';
    let show = false;
    if (watchLonger) {
      show = isSideDropdownCustom(getLongerSideDropdown(), trigger);
    } else if (watchOption) {
      show = isOptionCustom(watchOption, trigger);
    }
    panel.classList.toggle('hidden', !show);
    setHiddenFieldState(panel, show);
  });

  updateDepositNotes();
  syncLengthAddonPrice();
}

function initSideDropdowns() {
  if (hasMutualCustomMode()) return;

  document.querySelectorAll('[data-pdp-side-dropdown]').forEach((wrapper) => {
    const select = wrapper.querySelector('[data-pdp-custom-trigger]');
    const panel = wrapper.querySelector('[data-pdp-custom-panel]');
    const trigger = wrapper.dataset.triggerValue || CUSTOM_VALUE;
    if (!select || !panel) return;

    const update = () => {
      const isCustom = select.value === trigger;
      panel.classList.toggle('hidden', !isCustom);
      setHiddenFieldState(panel, isCustom);
      syncLengthAddonPrice();
    };

    select.addEventListener('change', update);
    update();
  });
}

function initVariantCustomTriggers() {
  const handler = () => toggleCustomPanels();

  document.addEventListener('change', (event) => {
    if (
      event.target.matches('variant-picker select.variant-option__select') ||
      event.target.matches('[data-pdp-custom-trigger]')
    ) {
      handler();
    }
  });

  document.addEventListener('variant:update', () => {
    document.querySelectorAll('product-price').forEach((priceEl) => {
      delete priceEl.dataset.pdpBaseCents;
    });
    handler();
    syncLengthAddonPrice();
  });
  handler();
}

function parseMoneyToCents(text) {
  const match = text.match(/\$?\s*([\d,]+(?:\.\d{2})?)/);
  if (!match) return null;
  const digits = match[1].replace(/,/g, '');
  const amount = Number.parseFloat(digits);
  if (Number.isNaN(amount)) return null;
  return Math.round(amount * 100);
}

function formatMoneyFromCents(cents) {
  if (window.Shopify?.formatMoney) {
    return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
  }
  return `$${(cents / 100).toFixed(2)}`;
}

function getAddonCentsForLongerSide() {
  const longerSelect = getLongerSideSelect();
  if (!longerSelect?.value) return 0;
  const value = longerSelect.value;
  const productForm = document.querySelector('product-form-component[data-pdp-fee-map]');
  if (productForm) {
    try {
      const map = JSON.parse(productForm.dataset.pdpFeeMap || '[]');
      const entry = map.find((entry) => entry.label === value);
      if (entry?.cents != null) return Number(entry.cents);
    } catch {
      return 0;
    }
  }
  const option = longerSelect.options[longerSelect.selectedIndex];
  return Number(option?.dataset.addonCents || 0);
}

function syncLengthAddonPrice() {
  const addonCents = getAddonCentsForLongerSide();
  document.querySelectorAll('product-price').forEach((priceEl) => {
    const container = priceEl.querySelector('[ref="priceContainer"]');
    if (!container) return;
    if (!priceEl.dataset.pdpBaseCents) {
      const moneyEl = container.querySelector('.price, .money, [class*="price"]');
      const parsed = parseMoneyToCents(moneyEl?.textContent || container.textContent || '');
      if (parsed != null) priceEl.dataset.pdpBaseCents = String(parsed);
    }
    const baseCents = Number(priceEl.dataset.pdpBaseCents || 0);
    if (!baseCents) return;
    const totalCents = baseCents + addonCents;
    const formatted = formatMoneyFromCents(totalCents);
    const moneyEl = container.querySelector('.price, .money, [class*="price"]') || container;
    if (moneyEl === container) {
      container.textContent = formatted;
    } else {
      moneyEl.textContent = formatted;
    }
  });
  document.querySelectorAll('[data-pdp-add-to-cart-price]').forEach((el) => {
    const productForm = el.closest('product-form-component');
    const baseCents = Number(document.querySelector('product-price')?.dataset.pdpBaseCents || 0);
    if (!baseCents) return;
    el.textContent = ` · ${formatMoneyFromCents(baseCents + addonCents)}`;
  });
}

function initDesignPicker() {
  document.querySelectorAll('[data-pdp-design-picker]').forEach((picker) => {
    const inputs = picker.querySelectorAll('.pdp-design-picker__input');
    if (inputs.length && !picker.querySelector('.pdp-design-picker__input:checked')) {
      inputs[0].checked = true;
      inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
    }

    picker.addEventListener('change', (event) => {
      const input = event.target;
      if (!input?.matches?.('.pdp-design-picker__input')) return;
      const imageUrl = input.dataset.designImage;
      if (!imageUrl) return;
      const mainImage = document.querySelector(
        '.product-media-container img, [data-testid="product-media"] img, .product-media img, media-gallery img'
      );
      if (mainImage) {
        mainImage.src = imageUrl;
        mainImage.srcset = '';
      }
    });
  });
}

function initConditionalDepositNotes() {
  document.querySelectorAll('.pdp-deposit-note').forEach((note) => {
    if (note.hasAttribute('data-pdp-deposit-note')) return;
    const text = note.textContent?.toLowerCase() || '';
    if (text.includes('custom sizes')) {
      note.setAttribute('data-pdp-deposit-note', '');
      note.setAttribute('data-watch-option', 'Size');
      note.setAttribute('data-trigger-value', 'Custom');
      note.classList.add('hidden');
    }
  });
}

function init() {
  initConditionalDepositNotes();
  initLongerSideFallbacks();
  initSideDropdowns();
  initVariantCustomTriggers();
  initDesignPicker();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
